import React, { useState } from 'react';
import { Button, Form, Input, InputNumber, Slider, Space } from 'antd';

const JourneyController = ({ clientMeta, handleClientMetaChange, handleAddStage, annualReturn, setAnnualReturn }) => {
  return (
    <Space direction={'vertical'}>
      <Button color="info" variant={'contained'} size={'large'} onClick={handleAddStage}>
        Add Stage
      </Button>
      <Form>
        <Form.Item label="Client Name">
          <Input value={clientMeta.name} onChange={(e) => handleClientMetaChange('name', e.target.value)} />
        </Form.Item>
        <Form.Item label="Age">
          <Space>
            <Slider
              min={18}
              max={120}
              value={clientMeta.age}
              onChange={(value) => handleClientMetaChange('age', value)}
              style={{ width: '150px' }}
            />
            <InputNumber
              min={18}
              max={120}
              value={clientMeta.age}
              onChange={(value) => handleClientMetaChange('age', value)}
              style={{ margin: '0 16px' }}
            />
          </Space>
        </Form.Item>
        <Form.Item label="Investments">
          <InputNumber
            min={0}
            defaultValue={100000}
            value={clientMeta.investments}
            onChange={(value) => handleClientMetaChange('investments', value)}
            formatter={value => `$ ${value}`}

          />
        </Form.Item>
        <Form.Item label="Estimated Annualized Return (%)">
          <InputNumber
            min={0}
            max={100}
            value={annualReturn}
            onChange={(value) => setAnnualReturn(value)}
            formatter={(value) => `${value}%`}
          />
        </Form.Item>
      </Form>
    </Space>
  );
};

export default JourneyController;
